import { ElementTypeDto } from 'api/elements/Models/ElementTypeDto';
import { SupplierDto } from 'api/suppliers/models/SupplierDto';
import { TaxDto } from 'api/taxes/models/TaxDto';
import { UnitDto } from 'api/units/models/UnitDto';
import { createContext } from 'react';
import { ColumnsOptionsSidebarColumnrder } from 'common/components/columnsOptionsSidebar/ColumnsOptionsSidebar';
import { LinesTableColumn } from './utils';

interface LinesDataProviderModel {
    units: UnitDto[];
    taxes: TaxDto[];
    suppliers: SupplierDto[];
    hiddenColumns: LinesTableColumn[];
    columnsOrder?: ColumnsOptionsSidebarColumnrder<LinesTableColumn>[];
    elementTypes?: ElementTypeDto[];
    isComponentEditor?: boolean;
    rootSectionDesignationOverride?: string;
}

const defaultValue: LinesDataProviderModel = {
    taxes: [],
    units: [],
    suppliers: [],
    hiddenColumns: [],
    columnsOrder: [],
    elementTypes: [],
    isComponentEditor: false,
    rootSectionDesignationOverride: undefined,
}

export const LinesDataProvider = createContext(defaultValue);
